import React, { useState, useEffect } from "react";
// import AboutUs from 'components/homepage/aboutus';
import Banner from 'components/homepage/banner';
// import Contact from 'components/homepage/contact';
// import HOMEPAGEFAQ from 'components/homepage/faq';
// import HomepageFifthComp from 'components/homepage/homepageFifthComp';
// import HomepageFourthComp from 'components/homepage/homePageFourthComp';
// import HomepageReviews from 'components/homepage/homepageReviews';
// import HomePageSecondComp from 'components/homepage/homepageSecondComp';
// import HomepageThirdComp from 'components/homepage/homepageThirdComp';
// import ReliableTranslation from 'components/homepage/reliableTranslation';
// import SupportedLang from 'components/homepage/supportedLanguages';
import Layout from 'components/layout';
import SEO from 'components/seo';
// import GetInTouch from '../components/getInTouch';
import loadable from '@loadable/component'


// import ValentinePopup from "components/homepage/valentinePopup";
// const OtherComponent = loadable(() => import('./OtherComponent'))

function Index() {

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
  }, []);

  const listenToScroll = () => {
    console.log(1);
    setScrolled(true);
    // window.removeEventListener("scroll", listenToScroll);
  };
  

  const HomepageThirdComp = loadable(() => import('components/homepage/homepageThirdComp'))
  const HomepageFourthComp = loadable(() => import('components/homepage/homePageFourthComp'))
  const HomepageFifthComp = loadable(() => import('components/homepage/homepageFifthComp'))
  const HomepageReviews = loadable(() => import('components/homepage/homepageReviews'))
  const Contact = loadable(()=>import('components/homepage/contact'))
  const ReliableTranslation = loadable(()=>import('components/homepage/reliableTranslation'))
  const SupportedLang = loadable(()=>import('components/homepage/supportedLanguages'))
  const AboutUs = loadable(()=>import('components/homepage/aboutus'))
  const HOMEPAGEFAQ = loadable(()=>import('components/homepage/faq'))
  const GetInTouch = loadable(()=>import('../components/getInTouch'))
  // const Banner  = loadable(()=>import('components/homepage/banner'))
  const HomePageSecondComp  = loadable(()=>import('components/homepage/homepageSecondComp'))

  return (
    <Layout>
      <SEO
        title="Professional Translation Services - Translation Agency | Tomedes"
        description="Professional translation services for any document type, language, and medium with a 1-year guarantee. Our translation company is ISO certified and online 24/7."
        keywords="translation, professional translation, translation services, language translation, translation company, translation agency"
        slug="/"
      />
      {/* <ValentinePopup /> */}
      <Banner />
      <HomePageSecondComp />
      { scrolled && 
      <>
      <HomepageThirdComp />
      <HomepageFourthComp />
      <HomepageFifthComp
        head="Trusted by"
        colorHead="95,000+"
        lastHeadText="Satisfied Clients Worldwide"
        content="At Tomedes, we work round the clock to provide you with the right service. Each member of our translation team ensures consistent quality across languages. Each linguist handles thousands of projects each year. This dedication to each translation project is shown in our 98% customer satisfaction rate from 95,000 clients."
        headingMobile="true"
      />
      <HomepageReviews />
      <Contact />
      <ReliableTranslation />
      <SupportedLang />
      <AboutUs />
      <HOMEPAGEFAQ />
      <GetInTouch />
      </>
      }
    </Layout>
  );
}

export default Index